module.exports = __webpack_public_path__ + "src/assets/media/video.4f27104e.mp4";